export const addAddress = (address, selector) => {
  const addressElement = document.querySelector(selector);

  if (addressElement)
    addressElement.innerHTML = address
}